import React from 'react'
import { Input, Icon } from 'semantic-ui-react'

export function NumericStepper({
    value,
    onChange,
    min = 0,
    max,
    step = 1,
    width,
    fluid,
    style,
    disabled = false,
}) {
    const numericValue =
        typeof value === 'number' && !Number.isNaN(value) ? value : 0

    const emitChange = nextRaw => {
        const next = Number(nextRaw)
        if (Number.isNaN(next)) return
        let clamped = Math.max(min, next)
        if (typeof max === 'number' && !Number.isNaN(max)) {
            clamped = Math.min(clamped, max)
        }
        onChange(clamped)
    }

    const handleChange = (e, { value: raw }) => {
        if (raw === '') {
            onChange('')
            return
        }
        emitChange(raw)
    }

    const handleBlur = () => {
        if (value === '' || value === null || value === undefined) {
            emitChange(0)
        } else {
            emitChange(value)
        }
    }

    const canDecrease = !disabled && numericValue > min
    const canIncrease =
        !disabled &&
        (typeof max !== 'number' || Number.isNaN(max) || numericValue < max)

    const decrease = () => {
        if (!canDecrease) return
        emitChange(numericValue - step)
    }

    const increase = () => {
        if (!canIncrease) return
        emitChange(numericValue + step)
    }

    const handleKeyDown = e => {
        if (e.key === 'ArrowUp') {
            e.preventDefault()
            decrease()
        } else if (e.key === 'ArrowDown') {
            e.preventDefault()
            increase()
        }
    }

    return (
        <div
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                borderRadius: 999,
                border: '1px solid #d0d7e2',
                padding: '2px 2px',
                background: '#f8fafc',
                opacity: disabled ? 0.55 : 1,
                ...style,
            }}
        >
            <button
                type="button"
                onClick={decrease}
                disabled={!canDecrease}
                style={{
                    border: 'none',
                    background: 'transparent',
                    cursor: canDecrease ? 'pointer' : 'default',
                    padding: '0 4px',
                    display: 'flex',
                    alignItems: 'center',
                    opacity: canDecrease ? 1 : 0.4,
                }}
            >
                <Icon name="minus" size="small" />
            </button>

            <Input
                type="number"
                min={min}
                step={step}
                value={
                    value === '' || value === null || value === undefined
                        ? ''
                        : numericValue
                }
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                className="score-input"
                fluid={fluid}
                width={width}
                disabled={disabled}
                style={{
                    border: 'none',
                    background: 'transparent',
                    textAlign: 'center',
                }}
                input={{
                    style: {
                        textAlign: 'center',
                        border: 'none',
                        background: 'transparent',
                        padding: '4px 8px',
                        width: '3rem',
                    },
                }}
            />

            <button
                type="button"
                onClick={increase}
                disabled={!canIncrease}
                style={{
                    border: 'none',
                    background: 'transparent',
                    cursor: canIncrease ? 'pointer' : 'default',
                    padding: '0 4px',
                    display: 'flex',
                    alignItems: 'center',
                    opacity: canIncrease ? 1 : 0.4,
                }}
            >
                <Icon name="plus" size="small" />
            </button>
        </div>
    )
}